import { Component, OnInit } from '@angular/core'
import { ArticleService } from '../../../services/article.service'
import { environment } from '../../../../environments/environment.prod'
import { Title, Meta } from '@angular/platform-browser'
import { SeoService } from 'src/app/services/seo.service'


@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss'],
})
export class BlogPageComponent implements OnInit {
  articles: any
  server: string = environment.blobURL
  allArticles: any[] = [] // Stocker tous les articles avant filtrage
  categories: any[] = [] // Array to hold categories

  currentPage: number = 1
  totalPages: number = 1
  totalArticles: number = 0 // Total des articles récupérés
  constructor (
    private articleService: ArticleService,
    private seoService: SeoService,
    private titleService: Title,
    private metaService: Meta
  ) {}

  filters: any = {
    search: null,
    category: "",
  }

  getAll () {
    if (!this.filters.search) delete this.filters.search
    if (!this.filters.category) delete this.filters.category
    this.articleService
      .getAllCategories()
      .subscribe((res: any) => (this.categories = res.data))
    this.getFilteredArticlesData(this.filters)
  }
  getFilteredArticlesData(filters: any): void {
    // Ensure page and limit are set
    filters.page = filters.page || 1;
    filters.limit = filters.limit || 10;
    
    this.articleService.getFilteredArticles(filters).subscribe((res: any) => {
      if (res.status === 200) {
        this.articles = res.data.data.articles;
        this.totalArticles = res.data.total;
        
        // Calculate total pages
        this.totalPages = Math.ceil(this.totalArticles / filters.limit);
        
        // Ensure current page is within bounds
        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages;
        }
      } else {
        this.articles = [];
        this.totalArticles = 0;
        this.totalPages = 1;
        this.currentPage = 1;
      }
    }, error => {
      this.articles = [];
      this.totalArticles = 0;
      this.totalPages = 1;
      this.currentPage = 1;
    });
  }

  applyFilters (): void {
    this.filters.page = 1 // Toujours revenir à la première page après un filtre
    this.filters.limit = 10 // Définir une limite par défaut pour éviter NaN
    console.log(this.filters)
    this.getFilteredArticlesData(this.filters)
  }

  clearFilters (): void {
    this.filters = { search: '', category: '' } // Réinitialiser les filtres
    this.getAll()
  }

  ngOnInit (): void {
    /* const filters = {
      isPublished: true,
      category: 1,
      page: 1,
      limit: 10,
      search: 'Angular',
      pageTitle: 'Introduction to Angular',
      canonical: 'angular-introduction',
      robots: 'index,follow',
      keywords: 'angular,typescript'
    };*/
    this.getAll()

    const script = document.getElementById('structuredDataScript')
    if (script) {
      script.remove()
    }
    //this.getAll()
    if (this.seoService.isServer()) {
      this.seoService.getAll().subscribe((res: any) => {
        const config = res.data
        // Title and Description

        this.titleService.setTitle(config.title)
        this.metaService.removeTag('description')
        this.metaService.updateTag({
          name: 'description',
          content: config.description,
        })

        // Canonical
        const link: HTMLLinkElement = this.createLinkElement()
        link.setAttribute('rel', 'canonical')
        link.setAttribute('href', config.canonical)
        document.head.appendChild(link)

        // Robots
        this.metaService.updateTag({ name: 'robots', content: config.robots })

        // KeyWords
        this.metaService.updateTag({
          name: 'keywords',
          content: config.keywords,
        })

        // Open Graph
        this.metaService.updateTag({
          property: 'og:title',
          content: config.og.title,
        })
        this.metaService.updateTag({
          property: 'og:description',
          content: config.og.description,
        })
        this.metaService.updateTag({
          property: 'og:image',
          content: config.og.image,
        })
        this.metaService.updateTag({
          property: 'og:url',
          content: config.og.url,
        })
        this.metaService.updateTag({
          property: 'og:type',
          content: config.og.type,
        })
        this.metaService.updateTag({
          property: 'og:site_name',
          content: config.og.site_name,
        })
        this.metaService.updateTag({
          property: 'og:locale',
          content: config.og.locale,
        })

        // Twitter Card
        this.metaService.updateTag({
          name: 'twitter:card',
          content: config.twitter.card,
        })
        this.metaService.updateTag({
          name: 'twitter:title',
          content: config.twitter.title,
        })
        this.metaService.updateTag({
          name: 'twitter:description',
          content: config.twitter.description,
        })
        this.metaService.updateTag({
          name: 'twitter:image',
          content: config.twitter.image,
        })
        this.metaService.updateTag({
          name: 'twitter:site',
          content: config.twitter.site,
        })
        this.metaService.updateTag({
          name: 'twitter:creator',
          content: config.twitter.creator,
        })

        // Structured Data
        const script: HTMLScriptElement = this.createScriptElement()
        script.type = 'application/ld+json'
        script.text = JSON.stringify(config.structuredData)
        document.head.appendChild(script)
      })
      this.getAll()
    }
  }
  private createLinkElement (): HTMLLinkElement {
    const link: HTMLLinkElement = document.createElement('link')
    return link
  }

  private createScriptElement (): HTMLScriptElement {
    const script: HTMLScriptElement = document.createElement('script')
    return script
  }
  // Helper function to calculate full stars
  fullStars (rating: number): number[] {
    return Array(Math.floor(rating)).fill(0)
  }

  // Helper function to calculate half stars
  halfStar (rating: number): boolean {
    return rating % 1 >= 0.5
  }

  // Helper function to calculate empty stars
  emptyStars (rating: number): number[] {
    return Array(5 - Math.ceil(rating)).fill(0)
  }

  // Add these methods to your component class
  getPaginationPages (): number[] {
    const pagesToShow = 5 // Number of page buttons to show
    const pages: number[] = []

    if (this.totalPages <= pagesToShow) {
      // Show all pages if total pages is less than pagesToShow
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i)
      }
    } else {
      // Show sliding window of pages
      let startPage: number

      if (this.currentPage <= Math.ceil(pagesToShow / 2)) {
        startPage = 1
      } else if (
        this.currentPage + Math.floor(pagesToShow / 2) >=
        this.totalPages
      ) {
        startPage = this.totalPages - pagesToShow + 1
      } else {
        startPage = this.currentPage - Math.floor(pagesToShow / 2)
      }

      for (let i = 0; i < pagesToShow; i++) {
        pages.push(startPage + i)
      }
    }

    return pages
  }

  // Update your existing changePage method to ensure it's robust
  changePage (page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return
    }
    this.currentPage = page
    this.filters.page = page
    this.getFilteredArticlesData(this.filters)

    // Optional: Scroll to top after page change
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
